import { render, staticRenderFns } from "./IconGear.vue?vue&type=template&id=778554bb&"
import script from "./IconGear.vue?vue&type=script&lang=js&"
export * from "./IconGear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports